<div class="lr-container">

    <div class="lr-header">
        <input type="text" class="searchbox" [(ngModel)]="blockFilter"
            [placeholder]="'LOADLOG.RESULT.FILTER.BLOCK' | translate" />
        <input type="text" class="searchbox" [(ngModel)]="textFilter"
            [placeholder]="'LOADLOG.RESULT.FILTER.TEXT' | translate" />
        <shared-filter class="lr-typefilter" [filterstrip]="typeFilter" (change)="onTypeFilterChange()">
        </shared-filter>
        <div class="lr-close" (click)="onClose()">
            <i class="fa fa-close"></i>
        </div>
    </div>

    <div class="lr-body">

        <div class="lr-empty" *ngIf="visibleBlocks().length === 0">
            {{ 'LOADLOG.RESULT.EMPTY' | translate }}
        </div>

        <div class="lr-block" *ngFor="let b of visibleBlocks()">

            <div class="lr-block-head" [ngClass]="typeClass(b.messageType)" (click)="toggle(b)">
                <i class="fa" [ngClass]="isCollapsed(b) ? 'fa-chevron-right' : 'fa-chevron-down'"></i>
                <span class="lr-block-code">{{ b.block }}</span>
                <span class="lr-block-type">{{ b.messageType }}</span>
                <span class="lr-block-count">{{ visibleMessages(b).length }}</span>
            </div>

            <table class="lr-table" *ngIf="!isCollapsed(b)">
                <tbody>
                    <tr *ngFor="let m of visibleMessages(b)" [ngClass]="typeClass(m.messageType)">
                        <td class="lr-col-type">{{ m.messageType }}</td>
                        <td class="lr-col-code">{{ m.messageCode }}</td>
                        <td class="lr-col-msg">{{ m.message }}</td>
                    </tr>
                </tbody>
            </table>

        </div>

    </div>

</div>
